declare global {
  interface Window {
    msMaxTouchPoints: number;
  }
  interface Navigator {
    msMaxTouchPoints: number;
  }
}

export const getIsTouchDevice = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
};
